import * as React from "react";

function SvgPencilIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={17}
      height={17}
      {...props}
    >
      <defs>
        <path
          d="M15.46 4.18c0-.12-.04-.24-.12-.32l-2.19-2.19a.469.469 0 00-.65 0l-.76.76 2.83 2.84c.46-.46.71-.72.77-.77.08-.07.12-.2.12-.32m1.54 0c0 .53-.2 1.03-.58 1.42l-1.85 1.85-5.01-5.02c1.11-1.1 1.73-1.72 1.85-1.84a1.989 1.989 0 012.83 0c.22.21 1.96 1.95 2.18 2.17.38.39.58.89.58 1.42M4.82 11.42c0-.2.08-.39.23-.55l5.6-5.6 1.09 1.09-5.6 5.6c-.16.15-.35.23-.55.23-.19 0-.39-.08-.54-.23a.776.776 0 01-.23-.54m7.79-4.19l1.09 1.08-6.15 6.15L0 17l2.55-7.54 6.14-6.15L9.77 4.4l-5.88 5.88-1.07 3.18.73.72 3.18-1.07 5.88-5.88z"
          id="pencil-icon_svg__a"
        />
      </defs>
      <use xlinkHref="#pencil-icon_svg__a" fill="#dedede" />
      <use
        xlinkHref="#pencil-icon_svg__a"
        fillOpacity={0}
        stroke="#000"
        strokeOpacity={0}
      />
    </svg>
  );
}

export default SvgPencilIcon;
